import { Voice } from '@purplefront/editor/data-access';

declare const twttr: any;
import { Component, ElementRef, Inject, Input, NgZone, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { BehaviorSubject, combineLatest, Observable, of, Subject } from 'rxjs';
import { Feed } from '@purplefront/catalog/data-access';
import { Langs, MetaService, TrackingService, WINDOW } from '@purplefront/shared';
import { Bookmark } from '@purplefront/bookmarks/data-access';
import { ActivatedRoute, Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import * as fromArticleModalStore from '@purplefront/article-modal/data-access';
import { ArticleService, downloadImage, getMoreLikeArticles } from '@purplefront/article-modal/data-access';
import * as fromAuthStore from '@purplefront/auth/data-access';
import * as fromRouterStore from '@purplefront/app-router/data-access';
import {
  AppRouterFacadeService,
  AppRouterState,
  selectArticleId,
  selectArticleLang,
  selectArticleSourceType,
  selectFeedSlug
} from '@purplefront/app-router/data-access';
import * as fromAudioStoryStore from '@purplefront/audio-story/data-access';
import { debounceTime, filter, switchMap, take, takeUntil, tap } from 'rxjs/operators';
import { Clipboard } from '@angular/cdk/clipboard';
import { EditorService } from '../../../../../../editor/data-access/src/lib/services/editor.service';
import { EtxIconsRegistryService } from '../../../../../../shared/src/lib/components/etx-icons/etx-icons-registry.service';
import {
  etxIconCopy,
  etxIconDownload,
  etxIconEdit,
  etxIconPlay,
  etxIconPlayPurple,
  etxIconPlayWhite
} from '../../../../../../shared/src/lib/components/etx-icons/etx-icons.model';
import * as fromFlashBriefingStore from '../../../../../../flash-briefing/data-access/src/lib/store/flash-briefing.reducer';
import { addSelectFlashBriefing, navigatedFromFlashBriefing } from '@purplefront/flash-briefing/data-access';
import { NgbAlert } from '@ng-bootstrap/ng-bootstrap';
import { isLogged } from '@purplefront/auth/data-access';
import { NgxSmartModalService } from 'ngx-smart-modal';
import JSZip from 'jszip';
import JSZipUtils from 'jszip-utils';
import { FileSaverService } from 'ngx-filesaver';
import KeenSlider from 'keen-slider';
import { TranslateService } from '@ngx-translate/core';
import { redirectToLogin } from '../../../../../../app-router/data-access/src/lib/_store/actions';
import { Location } from '@angular/common';

@Component({
  selector: 'app-article',
  templateUrl: './article.component.html',
  styleUrls: ['./article.component.scss']
})
export class ArticleComponent implements OnInit, OnDestroy {
  readonly parisModePlatformName = 'ETX Studio/Paris Modes Insider';
  @Input() contentLang: Langs;
  @Input() defaultVoice: Voice;
  public articleType: string;
  public feed$: Observable<Feed>;
  public lang$: Observable<Langs>;
  public bookmarks$: Observable<Bookmark[]>;
  public relatedArticles$: Observable<any>;
  public moreLikeArticles$: Observable<any>;
  public article: any;
  public articleLang$: Observable<any>;
  public user$: Observable<any>;
  public isLoading$: Observable<boolean>;
  public isLoaded$: Observable<boolean>;
  public isLoadingAudio$: Observable<boolean>;
  public isLoadingMoreLikeArticles$: Observable<boolean>;
  public isLoadedMoreLikeArticles$: Observable<boolean>;
  public srcset: string;
  public imageMap: string[] = [];
  public nbElements = [1, 2, 3];
  public isPlaying$: Observable<boolean>;
  public service: string;
  public copied = false;
  public semantics: {
    categories: [];
    terms: [];
  };
  public customDownloadLink: string;

  private _ngUnsubscribe$: Subject<void> = new Subject<void>();
  private _currentFeedSlug: string;
  public icon = 'fa-bookmark';
  public iconActive = 'fa-bookmark-o';
  public msgDuration = 3000;
  private _success = new Subject<string>();
  private _successCopiedEmbed = new Subject<string>();
  public successMessage = '';
  public successCopyEmbedMessage = '';
  public isLoggedIn: boolean;
  private currentGeneratedArticleId: any;

  @ViewChild('selfClosingAlert', { static: false }) selfClosingAlert: NgbAlert;
  @ViewChild('codeEmbedCopiedMsg', { static: false }) codeEmbedCopiedMsg: NgbAlert;
  @ViewChild('codeEmbedArea', { static: false }) codeEmbedArea: ElementRef;
  @ViewChild('openCodeEmbedBtn', { static: false }) openCodeEmbedBtn: ElementRef;
  @ViewChild('swiperWrapper') public swiperWrapper: any;
  @ViewChild('sliderRef') sliderRef: ElementRef<HTMLElement>;
  @ViewChild('articleRef') articleRef: ElementRef<HTMLElement>;

  loaded: boolean[] = [];
  slider: KeenSlider = null;
  currentSlide: number = 0;

  private articleWidth$ = new BehaviorSubject<number>(0);
  private observer: any;
  private iframes: any;
  loadingDownloadImage = false;

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _articleModalStore: Store<fromArticleModalStore.ArticleModalState>,
    private _authStore: Store<fromAuthStore.AuthState>,
    private _routerStore: Store<fromRouterStore.AppRouterState>,
    private _audioStoryStore: Store<fromAudioStoryStore.AudioStoryState>,
    private _appRouterFacade: AppRouterFacadeService,
    private _clipboard: Clipboard,
    private _editorService: EditorService,
    private _etxIconsRegistry: EtxIconsRegistryService,
    private _flashBriefingStore: Store<fromFlashBriefingStore.State>,
    private _articleService: ArticleService,
    private _ngxSmartModal: NgxSmartModalService,
    private _trackingService: TrackingService,
    private _metaService: MetaService,
    private _fileSaverService: FileSaverService,
    private zone: NgZone,
    private _translate: TranslateService,
    private _location: Location,
    private _appRouterStore: Store<AppRouterState>,
    @Inject(WINDOW) private window: Window
  ) {
    this._etxIconsRegistry.registerIcons([
      etxIconDownload,
      etxIconPlayPurple,
      etxIconPlay,
      etxIconEdit,
      etxIconDownload,
      etxIconCopy,
      etxIconPlayWhite
    ]);
  }

  ngOnInit() {
    this._authStore
      .pipe(select(isLogged), takeUntil(this._ngUnsubscribe$))
      .subscribe((loggedIn) => (this.isLoggedIn = loggedIn));
    this.getDataFromStore();
    this.getArticle();
    this.scrollToTop();
    this.handleCopiedMsg();
    this.handleCopiedCodeEmbedMsg();
  }

  redirectToRegister(): void {
    this._appRouterStore.dispatch(
      redirectToLogin({
        payload: {
          fromUrl: this._location.path()
        }
      })
    );
  }

  getArticle(): void {
    const articleId$ = this._routerStore.pipe(select(selectArticleId));
    const articleLang$ = this._routerStore.pipe(select(selectArticleLang));
    const articleSourceType$ = this._routerStore.pipe(select(selectArticleSourceType));

    combineLatest([articleId$, articleLang$, articleSourceType$])
      .pipe(
        takeUntil(this._ngUnsubscribe$),
        switchMap(([id, lang, source]) => {
          if (id == null ?? lang == null ?? source == null) {
            return of([]);
          }
          const params = {
            sourceType: source,
            articleLang: lang,
            articleId: id
          };
          return this._articleService.getArticle(params).pipe(
            takeUntil(this._ngUnsubscribe$),
            tap((res) => {
              this.article = res;
              if (this.article.platformName === this.parisModePlatformName) {
                this.article.video_url = this.replacePMIVideoSource(this.article.video_url);
                this.customDownloadLink = this.replacePMIDownloadSource(this.article.video_url);
              }

              this.semantics = this._articleService.mapSemantics(this.article.semantics);
              this.initMetaTags();
              this.trackArticleOpened();
              if (this.isLoggedIn) {
                this._articleModalStore.dispatch(getMoreLikeArticles({ payload: { article: this.article } }));
              }
              this.initTemplateDependencies();
              this.loadTwitterWidget();
            })
          );
        })
      )
      .subscribe();
  }

  loadTwitterWidget(): void {
    setTimeout(() => twttr.widgets.load(), 500);
  }

  replacePMIVideoSource(videoUrl: string): string {
    return videoUrl.replace('360-4_3', '720');
  }

  replacePMIDownloadSource(videoUrl: string): string {
    return videoUrl.replace('720', '1080');
  }

  initTemplateDependencies(): void {
    setTimeout(() => {
      this.iframes = this.articleRef.nativeElement.querySelectorAll('iframe');
      this.onResizeObserver();
      if (!this.sliderRef) {
        return;
      }
      this.setKeenSliderConfig();
    });
  }

  onResizeObserver() {
    this.observer = new ResizeObserver((entries) => {
      this.zone.run(() => {
        const width: number = Number(entries[0].contentRect.width.toFixed());
        this.articleWidth$.next(width);
        this.handleIframe();
      });
    });
    this.observer.observe(this.articleRef.nativeElement);
  }

  handleIframe() {
    const iframes = this.iframes;
    const iframesToManage = this.getIframesOnWhiteList(iframes);
    if (iframesToManage.length) {
      iframesToManage.forEach((elem: any) => {
        let articleWidth = this.articleWidth$.getValue();
        if (articleWidth > 550 && elem.domain !== 'anchor') {
          articleWidth = 550;
        }
        elem.iframe.width = articleWidth;
        elem.iframe.height = articleWidth / elem.ratio + elem.offset;
      });
    }
  }

  getIframesOnWhiteList(iframes) {
    const iframesToManage = [];
    if (iframes?.length) {
      iframes.forEach((iframe) => {
        const getDomainFromUrl = this.getDomainFromUrl(iframe.src);
        if (getDomainFromUrl) {
          const data: any = {
            iframe,
            domain: getDomainFromUrl.domain,
            ratio: getDomainFromUrl.ratio,
            offset: getDomainFromUrl.offset,
            parentNode: iframe.parentNode
          };
          data.parentNode.style = 'display:flex;justify-content:center;margin: 0 auto;';
          data.iframe.style =
            getDomainFromUrl.domain === 'anchor' ? 'max-width: auto; max-height: 160px' : 'max-width: 550px';
          iframesToManage.push(data);
          const imageRatio = this.getImageRatio(iframe);
          if (imageRatio) {
            data.ratio = imageRatio;
          }
          if (iframesToManage) {
            iframesToManage.push(data);
          }
        }
      });
    }
    return iframesToManage;
  }

  getImageRatio = (iframe: Element) => Number(iframe.getAttribute('data-ratio'));

  getDomainFromUrl(url: string): any {
    let domain = null;
    const dicoDomain = [
      { url: 'https://www.instagram.com', domain: 'instagram', ratio: 1 / 1, offset: 54 },
      { url: 'https://w.soundcloud.com', domain: 'soundcloud', ratio: 4 / 3, offset: 0 },
      { url: 'https://www.youtube.com', domain: 'youtube', ratio: 16 / 9, offset: 0 },
      { url: 'https://anchor.fm', domain: 'anchor', ratio: 5 / 1, offset: 0 }
    ];

    domain = dicoDomain.find((elem) => url?.search(elem.url) !== -1);
    return domain;
  }

  setKeenSliderConfig() {
    this.slider = new KeenSlider(this.sliderRef.nativeElement, {
      initial: this.currentSlide,
      slideChanged: (s) => {
        this.currentSlide = s.details().relativeSlide;
      },
      afterChange: (s) => {
        const idx = s.details().relativeSlide;
        this.loaded[idx] = true;
      },
      slidesPerView: 1,
      spacing: 50
    });
  }

  initMetaTags(): void {
    this._metaService.removeMetaTags();
    this._metaService.addArticleMetaTags(this.article);
  }

  handleCopiedMsg() {
    this._success.subscribe((message) => (this.successMessage = message));
    this._success.pipe(debounceTime(this.msgDuration)).subscribe(() => {
      if (this.selfClosingAlert) {
        this.selfClosingAlert.close();
      }
    });
  }

  handleCopiedCodeEmbedMsg() {
    this._successCopiedEmbed.subscribe((message) => (this.successCopyEmbedMessage = message));
    this._successCopiedEmbed.pipe(debounceTime(this.msgDuration)).subscribe(() => {
      if (this.codeEmbedCopiedMsg) {
        this.codeEmbedCopiedMsg.close();
      }
    });
  }

  scrollToTop() {
    this.window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }

  private getDataFromStore(): void {
    this._audioStoryStore
      .pipe(select(fromAudioStoryStore.selectCurrentGeneratedArticleId), takeUntil(this._ngUnsubscribe$))
      .subscribe((id) => (this.currentGeneratedArticleId = id));

    /*
     * Get loading state
     */
    this.isLoadingAudio$ = this._audioStoryStore.pipe(select(fromAudioStoryStore.selectLoadingAudioStories));

    this.isLoading$ = this._articleModalStore.pipe(select(fromArticleModalStore.selectLoadingArticle));
    this.isLoaded$ = this._articleModalStore.pipe(select(fromArticleModalStore.selectLoadedArticle));
    this.isLoadingMoreLikeArticles$ = this._articleModalStore.pipe(
      select(fromArticleModalStore.selectLoadingMoreLikeArticles)
    );

    this._routerStore
      .pipe(select(selectFeedSlug), takeUntil(this._ngUnsubscribe$))
      .subscribe((slug) => (this._currentFeedSlug = slug));

    /**
     * Get user datas
     */
    this.user$ = this._authStore.pipe(select(fromAuthStore.tokenCredentials));

    /**
     * Get more like articles
     */

    this.moreLikeArticles$ = this._articleModalStore.pipe(
      takeUntil(this._ngUnsubscribe$),
      select(fromArticleModalStore.moreLikeArticles)
    );

    /**
     * Get related articles
     */

    this.relatedArticles$ = this._articleModalStore.pipe(select(fromArticleModalStore.relatedArticles));

    this.isPlaying$ = this._audioStoryStore.pipe(select(fromAudioStoryStore.selectAudioStoryPlaying));
  }

  /**
   * Open article modal
   */

  showMltArticle(article) {
    this._appRouterFacade.goToArticlePage(article);
  }

  /*
   * Map article images srcset
   */

  getImageSrcset(index: number): string {
    const imageSizes = {
      s_default: '200w',
      s_medium: '645w',
      s_large: '900w'
    };

    Object.keys(imageSizes).map((key) => {
      const src = this.article.images[index][key] + ' ' + imageSizes[key];
      this.imageMap.push(src);
    });
    this.srcset = this.imageMap.slice(-3).toString();
    return this.srcset;
  }

  copyToClipboard(data, trackEvent?: string, dataType?: string): void {
    if (!trackEvent) this.trackEvent(`article-copy-article'}`);
    if (!this.isLoggedIn) {
      this.openNaggingModal();
      return;
    }
    if (dataType === 'short') {
      this._clipboard.copy(data);
      this._success.next('DESCRIPTION_COPIED');
      return;
    } else if (dataType === 'copyright') {
      this._clipboard.copy(`${this._translate.instant('PHOTOGRAPHY')} ${data}`);
      this._success.next('COPYRIGHT_COPIED');
      return;
    } else {
      const pending = this._clipboard.beginCopy(this.getTextToCopy(data));
      for (let i = 0; i < 3; i++) {
        const result = pending.copy();
        if (result) {
          this._success.next('ARTICLE_COPIED');
          break;
        }
      }
      pending.destroy();
    }
  }

  getTextToCopy(article) {
    return this._editorService.strip(article.header + '\n' + article.content);
  }

  downloadArticleImage(article, event?: Event) {
    if (event) {
      event.preventDefault();
    }
    if (!this.isLoggedIn) {
      this.openNaggingModal();
      return;
    }
    this.trackEvent('article-download-image');
    const payload = {
      sourceType: article.object_source_type,
      lang: article.lang,
      id: article.id,
      index: this.currentSlide
    };
    this._articleModalStore.dispatch(downloadImage({ payload }));
  }

  generateAndPlayAudio(): void {
    if (!this.isLoggedIn) {
      this.openNaggingModal();
      return;
    }
    const content = this._articleService.getStringWithoutEmbeded(
      this._articleService.stringToHTML(this.article.content)
    );
    this.trackEvent('article-play-article');
    const payload = {
      voiceId: this.defaultVoice.id,
      text: this._editorService.strip(this.article.title + '\n' + this.article.header + '\n' + content),
      articleId: this.article.id
    };
    if (this.article.id !== this.currentGeneratedArticleId) {
      this._audioStoryStore.dispatch(fromAudioStoryStore.generateAudioStoryItem({ payload }));
    } else {
      this._audioStoryStore.dispatch(fromAudioStoryStore.playPauseAudio({ payload: { playing: true } }));
    }
  }

  pauseAudio(): void {
    this._audioStoryStore.dispatch(fromAudioStoryStore.playPauseAudio({ payload: { playing: false } }));
  }

  editArticle() {
    if (!this.isLoggedIn) {
      this.openNaggingModal();
      return;
    }
    this._flashBriefingStore.dispatch(navigatedFromFlashBriefing({ navigationFromFlashBriefing: true }));
    this.trackEvent('article-edit-article');
    this._flashBriefingStore.dispatch(addSelectFlashBriefing({ article: this.article }));
    this._appRouterFacade.goToEditor(this.contentLang);
  }

  shareArticle() {
    this.trackEvent('article-share-article');
  }

  search(searchString: string) {
    if (!this.isLoggedIn) {
      this.openNaggingModal();
      return;
    }
    this.trackEvent('article-tags-article');
    this._router.navigate(['discover', this.contentLang], {
      queryParams: { search: searchString },
      queryParamsHandling: 'merge'
    });
  }

  openNaggingModal() {
    if (!this.isLoggedIn) {
      this._ngxSmartModal.open('auth-nagging-modal');
      return;
    }
  }

  trackArticleOpened() {
    this._trackingService.trackEvent({
      value: this.article.title,
      type: 'discover-read-article',
      payload: { mainCategory: this.article.mainCategory, contentLanguage: this.article.lang }
    });
  }

  trackEvent(type: string) {
    const payload = {
      feeds: this.article.categories,
      lang: this.article.lang
    };
    const value = this.article.title;
    this._trackingService
      .trackEvent({ type: type, value: value, payload: payload })
      .pipe(takeUntil(this._ngUnsubscribe$))
      .subscribe();
  }

  async onClickDownloadAllImages(event) {
    event.preventDefault();
    this.openNaggingModal();
    if (!this.isLoggedIn) return;
    this.createZipFile();
  }

  async createZipFile() {
    if (!this.article?.images?.length) return;
    this.loadingDownloadImage = true;
    const zip: JSZip = new JSZip();
    const images = this.article.images;
    let count = 0;
    const zipTitle = this.formatStringToFileTitle(this.article.title);
    const zipFilename = `${zipTitle}.zip`;
    images.forEach((image: any, imageIndex: number) => {
      JSZipUtils.getBinaryContent(image.source, (err, data) => {
        if (err) {
          throw err;
        }
        const title = this.formatStringToFileTitle(image.title);
        const filename = `${imageIndex + 1}_${title}.jpg`;
        zip.file(filename, data, { binary: true });
        count++;
        if (count === images.length) {
          this.saveFile(zip, zipFilename);
        }
      });
    });
  }

  saveFile(zip, zipFilename) {
    zip.generateAsync({ type: 'blob' }).then((content) => {
      this._fileSaverService.save(content, zipFilename);
      this.loadingDownloadImage = false;
    });
  }

  formatStringToFileTitle = (str: string) =>
    str
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^\w\s]|_/g, '')
      .trim()
      .replaceAll(' ', '_');

  /**
   * Prevent memory leaks
   */

  ngOnDestroy(): void {
    this._ngUnsubscribe$.next();
    this._ngUnsubscribe$.complete();
    if (this.slider) this.slider.destroy();
    this.observer.unobserve(this.articleRef.nativeElement);
  }
}
